export default {
  namespaced: true,
  state: {
    hiddenNavItems: []
  },
  mutations: {
    HIDE_NAV_ITEM (state, id) {
      const index = state.hiddenNavItems.indexOf(id)
      if (index === -1) {
        state.hiddenNavItems.push(id)
      }
    },
    SHOW_NAV_ITEM (state, id) {
      const index = state.hiddenNavItems.indexOf(id)
      if (index > -1) {
        state.hiddenNavItems.splice(index, 1)
      }
    }
  },
  actions: {
    hideNavItem ({ commit }, id) {
      commit('HIDE_NAV_ITEM', id)
    },
    showNavItem ({ commit }, id) {
      commit('SHOW_NAV_ITEM', id)
    }
  }
}
